import { cacheKeys } from "@constants/cache-keys";
import { EXAMS_LIST_STALE_TIME } from "@constants/stale-times";
import { type QueryClient, queryOptions } from "@tanstack/react-query";
import { fetchExamsList } from "api/commerce/exam-service";

export const examsListQueryOptions = (userLogicalId?: string) =>
	queryOptions({
		queryKey: [cacheKeys.exams, userLogicalId ?? ""],
		queryFn: ({ signal }) => fetchExamsList(signal),
		staleTime: EXAMS_LIST_STALE_TIME,
		enabled: Boolean(userLogicalId),
	});

export const refreshExamsListCache = async (queryClient: QueryClient) => {
	await queryClient.cancelQueries({ queryKey: [cacheKeys.exams] });
	queryClient.invalidateQueries({ queryKey: [cacheKeys.exams] });
};

export const setCachedExamDate = async (
	queryClient: QueryClient,
	userLogicalId: string,
	examId: string,
	examDate: string,
) => {
	const { queryKey } = examsListQueryOptions(userLogicalId);
	if (!queryClient.getQueryData(queryKey)) {
		await refreshExamsListCache(queryClient);
		return;
	}
	await queryClient.cancelQueries({ queryKey: [cacheKeys.exams] });
	queryClient.setQueryData(queryKey, (exams) =>
		exams?.map((item) =>
			item.exam.id === examId
				? { ...item, metadata: { ...item.metadata, examDate } }
				: item,
		),
	);
};

export const getCachedExamsList = (
	queryClient: QueryClient,
	userLogicalId?: string,
) =>
	userLogicalId
		? queryClient.getQueryData(examsListQueryOptions(userLogicalId).queryKey)
		: undefined;
